import s from './ChartTypeSelector.module.scss';

const CHART_TYPES = [
    { value: 'line', label: 'Line' },
    { value: 'bar', label: 'Bar' },
    { value: 'column', label: 'Column' },
    { value: 'area', label: 'Area' },
    { value: 'polar', label: 'Polar' },
    { value: 'treemap', label: 'TreeMap' },
    { value: 'timeline', label: 'Timeline' },
    { value: 'mixed', label: 'Mixed' },
    { value: 'heatmap', label: 'Heat Map' },
];

const ChartTypeSelector = ({ value, onChange }) => {
    return (
        <div className={s.Root}>
            {CHART_TYPES.map((type) => (
                <label
                    key={type.value}
                    className={`${s.Option} ${value === type.value ? s.OptionSelected : ''}`}>
                    <input
                        type="radio"
                        name="chartType"
                        value={type.value}
                        checked={value === type.value}
                        onChange={() => onChange(type.value)}
                        className={s.Radio}
                    />
                    <span className={s.Label}>{type.label}</span>
                </label>
            ))}
        </div>
    );
};

export default ChartTypeSelector;
